import { defineConfig } from '@chakra-ui/react';

// Chakra's default track (bg.muted) and selected-segment indicator
// (bg.emphasized) collapse to near-identical greys on this app's dark surface,
// so the selected segment all but vanishes. Rebuilt on the app's own surface
// tokens, which were stepped for contrast in both modes: the track gets a
// visible edge, and the indicator sits two surface steps above it in dark mode.
// Light mode keeps its white pill and soft shadow.
const config = defineConfig({
  theme: {
    slotRecipes: {
      segmentGroup: {
        // Chakra does not re-export the anatomy; these are its slot names.
        slots: ['root', 'label', 'item', 'itemText', 'itemControl', 'indicator'],
        base: {
          root: {
            bg: 'surface.muted',
            borderWidth: '1px',
            borderColor: 'border.light',
            boxShadow: 'none',
            '--segment-indicator-bg': {
              _light: 'colors.surface.background',
              _dark: 'colors.surface.accentStrong',
            },
            '--segment-indicator-shadow': {
              _light: 'shadows.sm',
              _dark: 'none',
            },
          },
        },
      },
    },
  },
});

export default config;
